import MainRouter from './navigation/mainNavigation';

function App() {
  return <MainRouter />;
}

export default App;
